<template>
    <div class="error-p">
            <p class="NoFindTit">抱歉，没有找到与“<em>{{$global.q}}</em>”相关的网页</p>
            <p class="NoFindp">PCauto建议您：</p>
            <p class="NoFindLi">尝试其他相关词，如同义，近义词等;</p>
            <p class="NoFindLi">看看输入的文字有没有错误;</p>
            <p class="NoFindLi">保留主要的关键字，减少不必要的文字;</p>
            <p class="NoFindLi">输入车型品牌厂商时，使用官方正式名称;</p>
            <p class="NoFindLi">若认为搜索结果不准确，欢迎向我们<a href="//my.pcauto.com.cn/action/report/report.jsp" target="_blank">意见反馈&gt;&gt;</a></p>
    </div>
</template>

<script>
    export default {
        name: 'ErrorActicle',
        props: {
            id: {
                type: Number,
                default: 0
            }
        },
        mounted() { //无结果页埋点
            this.countAd(this.id)
            this.countAd(7672)
        },
    }
</script>

<style lang="scss" scoped>
.error-p {
    .NoFindTit {
        background: url(//www1.pcauto.com.cn/2014/kuaisou/images/NoFind.png) no-repeat;
        height: 16px;
        line-height: 16px;
        padding-left: 20px;
        font-size: 14px;
        margin-top: 30px;
        color: #323232;
        em {
            color: #cc0000;
            word-break: break-all;
            word-wrap: break-word;
            font-style: normal;
        }
    }
    .NoFindp {
        font-size: 16px;
        font-weight: bold;
        color: #2f2f2f;
        padding-left: 20px;
        height: 16px;
        line-height: 16px;
        margin: 18px 0;
    }
    .NoFindLi {
        background: url(//www1.pcauto.com.cn/2014/kuaisou/images/NoFindLi.png) 20px 9px no-repeat;
        color: #777777;
        padding-left: 28px;
        height: 22px;
        line-height: 22px;
        a {
            color: #394c76;
        }
    }
}
</style>